<template>
  <Toast />
  <date-filter @buscar="buscar" />
  <div class="grid">
    <card-dashboard
      color="bg-purple-100"
      icon="folder-open"
      title="Em aberto"
      :xl_col="4"
      :lg_col="6"
      :value="status.aberto"
    />
    <card-dashboard
      color="bg-green-100"
      icon="check"
      title="Finalizado"
      :xl_col="4"
      :lg_col="6"
      :value="status.finalizado"
    />
    <card-dashboard
      color="bg-blue-100"
      icon="bars"
      title="Total"
      xl_col="4"
      :value="status.total"
    />
    <div class="col-12 md:col-6">
      <div class="card">
        <h6 class="text-center">
          <strong>Status das Solicitações</strong>
        </h6>
        <canvas id="chart-status" width="540"></canvas>
      </div>
    </div>
    <div class="col-12 md:col-6">
      <div class="card">
        <h6 class="text-center"><strong> Melhores Operadores</strong></h6>
        <canvas id="operadores" width="540"></canvas>
      </div>
    </div>
  </div>
</template>

<script>
//components
import CardDashboard from "./components/card_dashboard.vue";
import DateFilter from "./components/date_filter.vue";
// import { Chart, registerables } from "chart.js";
import { Chart } from "chart.js";
import Cores from "../../utilities/utils/Colors";

//Services
import SolicitationService from "../../service/solicitation/solicitation_service";

export default {
  components: {
    CardDashboard,
    DateFilter,
  },
  data() {
    return {
      status: [],
      mes: null,
      ano: null,
      service: new SolicitationService(),
      chartStatus: null,
      chartMelhores: null,
    };
  },
  created() {
    this.mes = new Date().getMonth() + 1;
    this.ano = new Date().getFullYear();
    /*
    if (sessionStorage.getItem("token")) {
      this.mes = new Date().getMonth() + 1;
      this.ano = new Date().getFullYear();
    } else {
      this.$toast.add({
        severity: "warn",
        summary: "Atenção!",
        detail: "Usuário desconectado! Você precisa fazer login novamente",
        life: 6000,
      });
      window.location.replace(this.$UrlIntranet);
    }*/
  },
  mounted() {
    this.buscar(this.mes, this.ano);
  },
  methods: {
    createChart() {
      if (this.chartStatus !== null) this.chartStatus.destroy();
      const ctx = document.getElementById("chart-status");
      this.chartStatus = new Chart(ctx, {
        type: "doughnut",
        data: {
          labels: ["Aberto", "Finalizado"],
          datasets: [
            {
              data: [this.status.aberto, this.status.finalizado],
              backgroundColor: ["rgb(239, 98, 98)", "rgb(32, 208, 119)"],
              borderColor: ["rgb(168, 61, 59)", "rgb(3, 141, 74)"],
              borderWidth: 0,
            },
          ],
        },
      });
      this.chartStatus.update();
    },
    buscar(mes, ano) {
      this.mes = mes;
      this.ano = ano;
      this.countStatus();
      this.contarMelhoresOperadores();
    },
    countStatus() {
      this.service
        .countStatus(this.mes, this.ano)
        .then((data) => {
          if (data.status === 200) {
            this.status = data.data;
            this.createChart();
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    contarMelhoresOperadores() {
      this.service
        .contarMelhoresOperadores(this.mes, this.ano)
        .then((response) => {
          if (this.chartMelhores !== null) this.chartMelhores.destroy();
          const ctxMelhores = document.getElementById("operadores");
          this.chartMelhores = new Chart(ctxMelhores, {
            type: "bar",
            data: {
              labels: [],
              datasets: [
                {
                  data: [],
                  backgroundColor: Cores,
                  borderColor: Cores,
                  borderWidth: 1,
                },
              ],
            },
            options: {
              scales: {
                y: {
                  beginAtZero: true,
                },
              },
              legend: {
                display: false,
              },
              tooltips: {
                callbacks: {
                  label: function (tooltipItem) {
                    return tooltipItem.yLabel;
                  },
                },
              },
            },
          });
          for (let i = 0; i < response.length; i++) {
            this.chartMelhores.data.datasets[0].data.push(response[i].value);
            this.chartMelhores.data.labels.push(response[i].key);
          }
          this.chartMelhores.update();
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>
<style lang="scss" scoped></style>
